import type { FC, ReactNode } from 'react';
import { cn } from '../utils/cn';


type PrizeStatTileSurface = 'card' | 'pane';

const SURFACES: Record<PrizeStatTileSurface, { rest: string; press: string }> = {
  card: { rest: 'rounded-xl bg-white/15', press: 'active:bg-white/25' },
  pane: { rest: 'rounded-[5px] bg-white/[0.055]', press: 'active:bg-white/[0.1]' },
};

interface PrizeStatTileProps {
  icon?: ReactNode;
  children: ReactNode;
  onClick?: () => void;
  surface?: PrizeStatTileSurface;
  className?: string;
}

export const PrizeStatTile: FC<PrizeStatTileProps> = ({ icon, children, onClick, surface = 'card', className }) => {
  const inner = (
    <>
      {icon}
      <div className="min-w-0 flex-1 leading-tight">{children}</div>
    </>
  );
  const { rest, press } = SURFACES[surface];
  const shell = cn('flex min-w-0 items-center gap-2', rest, 'px-3 py-2 text-start', className);

  if (!onClick) {
    return <div className={shell}>{inner}</div>;
  }
  return (
    <button type="button" onClick={onClick} className={cn(shell, 'transition', press)}>
      {inner}
    </button>
  );
};

export const PrizeStatTilePair: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => (
  <div className={cn('grid grid-cols-2 gap-2', className)}>{children}</div>
);
